// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventPresentmentDigitalCredentialsMdocApi
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.eventlogger.EventPresentmentData
import org.multipaz.eventlogger.toDataItem
import org.multipaz.eventlogger.fromDataItem

fun EventPresentmentDigitalCredentialsMdocApi.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "qPh-6BtqJ9-JcHT1ifPxMi5Fezo3tFYce3q0lCKt6TI")
val EventPresentmentDigitalCredentialsMdocApi_cborSchemaId = ByteString(-88, -8, 126, -24, 27, 106, 39, -33, -119, 112, 116, -11, -119, -13, -15, 50, 46, 69, 123, 58, 55, -76, 86, 28, 123, 122, -76, -108, 34, -83, -23, 50)

fun EventPresentmentDigitalCredentialsMdocApi.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "PresentmentDigitalCredentialsMdocApi")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentData", this.presentmentData.toDataItem())
    val appId = this.appId
    if (appId != null) {
        builder.put("appId", Tstr(appId))
    }
    builder.put("origin", Tstr(this.origin))
    builder.put("protocol", Tstr(this.protocol))
    builder.put("requestJson", Tstr(this.requestJson))
    builder.put("responseJson", Tstr(this.responseJson))
    builder.put("deviceResponse", this.deviceResponse)
    return builder.end().build()
}

fun EventPresentmentDigitalCredentialsMdocApi_fromDataItem(dataItem: DataItem): EventPresentmentDigitalCredentialsMdocApi {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentData = EventPresentmentData.fromDataItem(dataItem["presentmentData"])
    val appId0 = if (dataItem.hasKey("appId")) {
        dataItem["appId"].asTstr
    } else {
        null
    }
    val origin = dataItem["origin"].asTstr
    val protocol = dataItem["protocol"].asTstr
    val requestJson = dataItem["requestJson"].asTstr
    val responseJson = dataItem["responseJson"].asTstr
    val deviceResponse = dataItem["deviceResponse"]
    return EventPresentmentDigitalCredentialsMdocApi(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentData = presentmentData,
        appId = appId0,
        origin = origin,
        protocol = protocol,
        requestJson = requestJson,
        responseJson = responseJson,
        deviceResponse = deviceResponse,
    )
}
